import { useState, useMemo, useEffect } from "react";
import { getFiles } from "../../api";

export const usePayrollAttachments = ({
  payrollId,
  values,
  formValues
}) => {

  const [attachments, setAttachments] = useState([]);
  const [currentAttachmentIndex, setCurrentAttachmentIndex] = useState(0);

  const currentFile = attachments[currentAttachmentIndex];

  // =====================================================
  // Current Attachment Preview URL
  // =====================================================

  const activeIframeSrc = useMemo(() => {
    let src =
      currentFile?.AwsPath ||
      formValues?.payrollFilePath ||
      "";

    if (
      src &&
      src.toLowerCase().includes(".pdf") &&
      !src.includes("#")
    ) {
      src += "#toolbar=1&view=FitH&scrollbar=1";
    }

    return src;
  }, [currentFile, formValues?.payrollFilePath]);

  // =====================================================
  // Show Preview Panel
  // =====================================================

  const showPreviewPanel = useMemo(() => {
    return (
      attachments.length > 0 ||
      (
        typeof activeIframeSrc === "string" &&
        activeIframeSrc.toLowerCase().includes(".pdf")
      )
    );
  }, [attachments, activeIframeSrc]);

  // =====================================================
  // Load Attachments
  // =====================================================

  useEffect(() => {
    if (!payrollId) return;

    const fetchMainAttachments = async () => {
      try {
        const response = await getFiles(
          payrollId || values?.payRollID
        );

        if (
          (response?.StatusCode === 200 ||
            response?.Status === "File found") &&
          response.Files?.length > 0
        ) {
          const validFiles = response.Files.filter(f => {
            const name =
              (f.Filename || f.FileName || "")
                .toLowerCase();

            return (
              !name.endsWith(".xls") &&
              !name.endsWith(".xlsx") &&
              !name.endsWith(".csv")
            );
          });

          setAttachments(validFiles);
          setCurrentAttachmentIndex(0);
        }
      } catch (error) {
        console.error(
          "Failed to fetch main attachments",
          error
        );
      }
    };

    fetchMainAttachments();
  }, [payrollId, values?.payRollID]);

  return {
    attachments,
    setAttachments,

    currentAttachmentIndex,
    setCurrentAttachmentIndex,

    currentFile,
    activeIframeSrc,
    showPreviewPanel
  };
};